var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.any
      ? _c("div", { staticClass: "alert alert-danger" }, [
          _c(
            "ul",
            { staticClass: "mb-0 list-unstyled small" },
            _vm._l(_vm.value.validations, function(validation) {
              return _c("li", { key: validation.index }, [
                _vm._v(
                  "\n                " +
                    _vm._s(validation.value) +
                    "\n            "
                )
              ])
            }),
            0
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }